import { createAsyncThunk, createSlice,PayloadAction } from '@reduxjs/toolkit';
import { KeyManager,KeyManagerPlugins,KeyType} from "../../../stellar/wallet-sdk";
import { Networks } from "@stellar/stellar-sdk";
import {EncryptWalletKeysParams} from '../../../../types/types';
import { Key } from '../../../stellar/wallet-sdk/types';
import { CapacitorKeyStore } from '../../../stellar/wallet-sdk/plugins/CapacitorStorage';
import {Wallet} from '@stellar/typescript-wallet-sdk';

const isTestnet = import.meta.env.VITE_isTestnet==='true'?true:false;
const walletInfo_keyid = 'walletInfo_keyid';

const secureKeyManager = new KeyManager({
    keyStore: new CapacitorKeyStore(),
});
secureKeyManager.registerEncrypter(KeyManagerPlugins.ScryptEncrypter);
secureKeyManager.setDefaultNetworkPassphrase(isTestnet? Networks.TESTNET: Networks.PUBLIC)

type WalletInfoState = "LOADING" | "READY" | "ERROR";

interface WalletInfo  {
    info:Key,
    infoState:WalletInfoState,
    errorMessage:string
}

const initialState:WalletInfo = {

    info:{

        id:'',
        network:'',
        publicKey:'',
        privateKey:'',
        extra:'',
        type:''
    },
    infoState:'READY',
    errorMessage:""

}

const walletInfo = createSlice({
    name: "walletInfo",
    initialState,
    reducers: {

         // START LOADING
        startLoading(state) {
            state.infoState = 'LOADING';
        },

       // HAS ERROR
        hasError(state, action) {
            state.infoState = 'ERROR'
            state.errorMessage = action.payload;
        },
  
        addWalletInfo(state,action:PayloadAction<any>){
            
            state.info = action.payload;
            state.infoState = 'READY';
            state.errorMessage = ''
        },

    },
    extraReducers: function(builder){
        
        builder.addCase(decryptWalletKeys.pending,(state)=>{
            state.infoState = 'LOADING';

        })
        builder.addCase(decryptWalletKeys.fulfilled,(state,action:PayloadAction<Key>)=>{

            state.info.type = action.payload.type;
            state.info.extra = action.payload.extra;
            state.info.id = action.payload.id;
            state.info.network = action.payload.network;
            state.info.path = action.payload.path;
            state.info.privateKey = action.payload.privateKey;
            state.info.publicKey = action.payload.publicKey;
            state.infoState='READY';
                
        })
        builder.addCase(decryptWalletKeys.rejected,(state,action)=>{
            state.errorMessage = String(action.error.message);
            state.infoState ='ERROR';
            
        })

        builder.addCase(encryptWalletKeys.pending,(state,action)=>{
            state.infoState = 'LOADING';

        })
        builder.addCase(encryptWalletKeys.fulfilled,(state,action:PayloadAction<any>)=>{

            state.info.type = action.payload.type;
            state.info.extra = action.payload.extra;
            state.info.id = action.payload.id;
            state.info.network = action.payload.network;
            state.info.path = action.payload.path;
            state.info.privateKey = action.payload.privateKey;
            state.info.publicKey = action.payload.publicKey;
            state.infoState='READY';

        })
        builder.addCase(encryptWalletKeys.rejected,(state,action)=>{
            state.errorMessage = String(action.error.message);
            state.infoState ='ERROR';
            
        })
    }
});

  export const {addWalletInfo} = walletInfo.actions;
  
  export const decryptWalletKeys = createAsyncThunk('/decryptWallet',async(password:string,{ rejectWithValue })=>{

    try {

        let walletInfo = await secureKeyManager.loadKey(walletInfo_keyid,password);
        
        return walletInfo

    } catch (error:any) {
        
        return rejectWithValue(error.Error) 
        
    }

  })

  export const encryptWalletKeys = createAsyncThunk('/encryptWallet',async(params:EncryptWalletKeysParams,{ rejectWithValue })=>{
  
   const wallet = isTestnet?Wallet.TestNet():Wallet.MainNet();
   const account = wallet.stellar().account();
   const accountKeyPair = account.createKeypair();

    const  key:Key = {
        id:walletInfo_keyid,
        publicKey: accountKeyPair.publicKey,
        privateKey: accountKeyPair.secretKey,
        type: KeyType.plaintextKey,
        network: isTestnet? Networks.TESTNET: Networks.PUBLIC,
        extra:undefined
        
    };

    try {

        await secureKeyManager
        .storeKey({
            
            key: key,
            password: params.password,
            encrypterName: KeyManagerPlugins.ScryptEncrypter.name,
        })

    } catch (err) {
        return rejectWithValue(err) 
    }
    
  })

  export default walletInfo.reducer;